import { render, staticRenderFns } from "./schqtchangehistory.vue?vue&type=template&id=2dd7bd17&scoped=true&"
import script from "./schqtchangehistory.vue?vue&type=script&lang=js&"
export * from "./schqtchangehistory.vue?vue&type=script&lang=js&"
import style0 from "./schqtchangehistory.vue?vue&type=style&index=0&id=2dd7bd17&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7bd17",
  null
  
)

export default component.exports